import type { ModelData } from '@/shared/stores/model-utils'

export const model16InitialModel: ModelData = {
    name: 'Template 16 - Double Door With Solid Frames',
    modelId: 'model16',
    type: 'DOOR',
    description:
      '16-variant double door with solid frames and dual door opening with openable window',
    width: 3600,
    height: 2200,
    photoId: null,
    serviceNames: [],
    serviceIds: [],
    parameters: [
      //outer frames
      {
        positionId: 'top_frame_profile',
        type: 'PROFILE',
        width: 3600,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 3540, y: 0, z: 0 },
      },

      //bottom frames
      {
        positionId: 'bottom_left_frame_profile',
        type: 'PROFILE',
        width: 700,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 2140, z: 0 },
      },
      {
        positionId: 'bottom_right_frame_profile',
        type: 'PROFILE',
        width: 700,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2900, y: 2140, z: 0 },
      },
      {
        positionId: 'bottom_center_frame_profile_1',
        type: 'PROFILE',
        width: 2200,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 700, y: 2140, z: 0 },
      },
      //vertical frames
      {
        positionId: 'left_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 640, y: 60, z: 0 },
      },
      {
        positionId: 'middle_vertical_frame_profile_center',
        type: 'PROFILE',
        width: 60,
        height: 2080,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1770, y: 60, z: 0 },
      },
      {
        positionId: 'right_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2900, y: 60, z: 0 },
      },

      //horizontal frames
      {
        positionId: 'middle_horizontal_frame_profile_1',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 1040, z: 0 },
      },
      {
        positionId: 'middle_horizontal_frame_profile_2',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 1040, z: 0 },
      },

      //top window frames
      //left top window frames
      {
        positionId: 'top_window_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 980,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 60, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'top_window_1_left_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 120, z: 10 },
            },
            {
              positionId: 'top_window_1_left_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 800, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 980,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 580, y: 60, z: 0 },

        hardware: {
          handles: [
            {
              positionId: 'window_vertical_handle_left',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 5, y: 405, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_1_top_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 60, z: 0 },
      },
      {
        positionId: 'top_window_1_bottom_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 980, z: 0 },
      },
      //right top window frames
      {
        positionId: 'top_window_2_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 980,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 3480, y: 60, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'top_window_2_right_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 120, z: 10 },
            },

            {
              positionId: 'top_window_2_right_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 800, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_2_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 980,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 60, z: 0 },
        hardware: {
          handles: [
            {
              positionId: 'window_vertical_handle_left',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 5, y: 405, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_2_top_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 60, z: 0 },
      },
      {
        positionId: 'top_window_2_bottom_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 980, z: 0 },
      },

      // Middle Vertical Separator

      // Glass Panels
      {
        positionId: 'left_glass_panel_opanable',
        type: 'GLASS',
        width: 460,
        height: 860,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 120, y: 120, z: 0 },
      },
      {
        positionId: 'left_glass_panel',
        type: 'GLASS',
        width: 580,
        height: 1040,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 60, y: 1100, z: 0 },
      },
      {
        positionId: 'right_glass_panel_opanable',
        type: 'GLASS',
        width: 460,
        height: 860,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 3020, y: 120, z: 0 },
      },
      {
        positionId: 'right_glass_panel',
        type: 'GLASS',
        width: 580,
        height: 1040,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 2960, y: 1100, z: 0 },
      },

      {
        positionId: 'middle_glass_panel_1',
        type: 'GLASS',
        width: 1070,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 700, y: 60, z: 0 },
      },
      {
        positionId: 'middle_glass_panel_2',
        type: 'GLASS',
        width: 1070,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 1830, y: 60, z: 0 },
      },
    ],
    doorConfiguration: {
      type: 'fixed_panels',
      totalDoorWidth: 2200,
      individualDoorWidth: [1100, 1100],
      totalHandles: 0,
      openingDirection: 'none',
      hingePosition: 'none',
      leftDoorWidth: 1100,
      rightDoorWidth: 1100,
      centerSeparatorWidth: 40,
    },
  }
